/**
 * <s-sticky-header> — Marks the floating header as scrolled so CSS can tighten it.
 *
 * Sets the `data-scrolled` attribute on itself once the page scrolls past a
 * small threshold, and removes it back at the top. All visual changes live in
 * utility classes (group-data-[scrolled]/header:*) on the descendants.
 */
class SStickyHeader extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    window.addEventListener('scroll', this.#queue, { signal: this.#ac.signal, passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #queue = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(this.#update);
  };

  #update = () => {
    this.toggleAttribute('data-scrolled', window.scrollY > 12);
  };
}

if (!customElements.get('s-sticky-header')) {
  customElements.define('s-sticky-header', SStickyHeader);
}
